import create, { GetState, SetState } from 'zustand';
import InkindUserUpdate from '@gik/inkind-page/models/InkindUserUpdate';

export interface IUserUpdatesStore {
  updates: InkindUserUpdate[];
  setUpdates: (updates: InkindUserUpdate[]) => void;
}

export const [useUserUpdatesStore, userUpdatesStoreApi] = create<IUserUpdatesStore>(
  (set: SetState<IUserUpdatesStore>, get: GetState<IUserUpdatesStore>) => ({
    updates: [],
    setUpdates: updates => set(() => ({ updates })),
  })
);
